import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams, useHistory, NavLink } from 'react-router-dom';
import swal from 'sweetalert';
import Footer from '../components/Footer';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';
import { BASEURL } from '../Config';

const EditClass = () => {
    const { uuid } = useParams();
    const history = useHistory();

    const [name, setName] = useState('');

    const [errors, setErrors] = useState({
        name: false,
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const classRes = await axios.get(`${BASEURL}/api/v1/elp/classes/fetch/${uuid}`);
                const { name, } = classRes.data;
                setName(name);
            } catch (error) {
                console.error('Fetch class error:', error);
            }
        };

        fetchData();
    }, [uuid]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'name') setName(value);
    };

    const validateData = () => {
        const newErrors = {
            name: !name,
        };

        setErrors(newErrors);
        return Object.values(newErrors).some((error) => error);
    };

    const handleUpdate = async () => {
        if (validateData()) {
            swal('Error in Updating Class', 'Fill the required fields', 'error');
            return;
        }

        const updateObj = {
            name
        };

        try {
            const res = await axios.put(`${BASEURL}/api/v1/elp/classes/update/${uuid}`, updateObj);
            if (res.status === 200) {
                swal('Success', 'Class updated successfully', 'success').then(() => {
                    history.push('/classes');
                });
            }
        } catch (error) {
            console.error('Update error:', error);
            swal('Error in Updating Class', error.response?.data || 'An error occurred', 'error');
        }
    };

    return (
        <div id="wrapper">
            <Sidebar act="classes" />
            <div className="content-page">
                <div className="content">
                    <Topbar act="Edit Class" breadcrumbItems={["ELP", { label: 'Classes', path: '/classes' }, "Edit Class"]} />
                    <div className="container-fluid main-container">
                        <div className="card">
                            <div className="card-body main-card">
                                <div className="row">
                                    <div className="col-md-4 col-sm-12">
                                        <div className="mb-3">
                                            <label htmlFor="bookname" className="form-label">Class Name *</label>
                                            <input
                                                type="text"
                                                id="bookname"
                                                className="form-control"
                                                onChange={handleChange}
                                                name="name"
                                                placeholder="Enter Class Name"
                                                value={name}
                                            />
                                            {errors.name && <p className="errTxt">Class Name is Required</p>}
                                        </div>
                                    </div>
                                </div>

                                <div className="mb-2 d-flex">
                                    <button type="submit" className="btn btn-customprimary" onClick={handleUpdate}>Update</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default EditClass;
